'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _SelectEditor = require('./SelectEditor');

var _reactSpreadsheetGrid = require('react-spreadsheet-grid');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GridInput = function (_React$PureComponent) {
  (0, _inherits3.default)(GridInput, _React$PureComponent);

  function GridInput(props) {
    (0, _classCallCheck3.default)(this, GridInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GridInput.__proto__ || (0, _getPrototypeOf2.default)(GridInput)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  (0, _createClass3.default)(GridInput, [{
    key: 'getInputNode',
    value: function getInputNode() {
      return _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.prepareFocus(this.props.focus);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var _this2 = this;

      var value = _ref.value,
          focus = _ref.focus;
      this.setState({
        value: value
      }, function () {
        _this2.prepareFocus(focus);
      });
    }
  }, {
    key: 'prepareFocus',
    value: function prepareFocus(focus) {
      var input = this.getInputNode();

      if (focus) {
        input.focus();
        this.onFocus(input);
      } else if (input === document.activeElement) {
        input.blur();
      }
    }
  }]);
  return GridInput;
}(_react2.default.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.commitKeys = ["Enter", "Tab"];
  this.state = {
    value: ""
  };

  this.onKeyDown = function (e) {
    if (_this8.commitKeys.indexOf(e.key) >= 0) {
      e.preventDefault();

      var input = _this8.getInputNode();

      input.blur();
    }
  };

  this.onChange = function (value) {
    _this8.setState({
      value: value
    });
  };

  this.onBlur = function () {
    if (_this8.props.onChange) {
      _this8.props.onChange(_this8.state.value);
    }
  };

  this.onFocus = function (input) {};
};

var WrappedInput = function (_GridInput) {
  (0, _inherits3.default)(WrappedInput, _GridInput);

  function WrappedInput() {
    var _ref2;

    var _temp, _this3, _ret;

    (0, _classCallCheck3.default)(this, WrappedInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = WrappedInput.__proto__ || (0, _getPrototypeOf2.default)(WrappedInput)).call.apply(_ref2, [this].concat(args))), _this3), _this3.onFocus = function (input) {
      input.selectionStart = input.value.length;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(WrappedInput, [{
    key: 'render',
    value: function render() {
      var value = this.state.value;
      return _react2.default.createElement(_reactFulcrum.Input, (0, _extends3.default)({}, this.props, {
        value: value,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onBlur: this.onBlur
      }));
    }
  }]);
  return WrappedInput;
}(GridInput);

var WrappedSelect = function (_GridInput2) {
  (0, _inherits3.default)(WrappedSelect, _GridInput2);

  function WrappedSelect() {
    var _ref3;

    var _temp2, _this4, _ret2;

    (0, _classCallCheck3.default)(this, WrappedSelect);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = WrappedSelect.__proto__ || (0, _getPrototypeOf2.default)(WrappedSelect)).call.apply(_ref3, [this].concat(args))), _this4), _this4.onFocus = function (input) {}, _temp2), (0, _possibleConstructorReturn3.default)(_this4, _ret2);
  }

  (0, _createClass3.default)(WrappedSelect, [{
    key: 'getInputNode',
    value: function getInputNode() {
      var input = _reactDom2.default.findDOMNode(this).getElementsByTagName("input")[0];

      return input;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_SelectEditor.RawSelect, (0, _extends3.default)({}, this.props, {
        openOnFocus: true,
        onKeyDown: this.handleKeyDown
      }));
    }
  }]);
  return WrappedSelect;
}(GridInput);

var WrappedSwitch = function (_GridInput3) {
  (0, _inherits3.default)(WrappedSwitch, _GridInput3);

  function WrappedSwitch() {
    var _ref4;

    var _temp3, _this5, _ret3;

    (0, _classCallCheck3.default)(this, WrappedSwitch);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = WrappedSwitch.__proto__ || (0, _getPrototypeOf2.default)(WrappedSwitch)).call.apply(_ref4, [this].concat(args))), _this5), _this5.commitKeys = ["Enter", "Tab"], _this5.onFocus = function (input) {
      _this5.setState({
        value: !_this5.state.value
      });
    }, _temp3), (0, _possibleConstructorReturn3.default)(_this5, _ret3);
  }

  (0, _createClass3.default)(WrappedSwitch, [{
    key: 'render',
    value: function render() {
      var value = this.state.value;
      return _react2.default.createElement(_reactFulcrum.Switch, (0, _extends3.default)({}, this.props, {
        value: value,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onBlur: this.onBlur
      }));
    }
  }]);
  return WrappedSwitch;
}(GridInput);

var getEditor = function getEditor(columnType, onChange, value, status) {
  var type = columnType.type;
  console.log("columnType ", columnType);

  if (type === "boolean") {
    return _react2.default.createElement(WrappedSwitch, (0, _extends3.default)({}, columnType, {
      value: value || false,
      onChange: onChange
    }, status));
  } else if (type === "select") {
    return _react2.default.createElement(WrappedSelect, (0, _extends3.default)({}, columnType, {
      type: columnType,
      value: value || false,
      onChange: onChange
    }, status));
  } else if (type === "tags") {
    return _react2.default.createElement(WrappedSelect, (0, _extends3.default)({
      multi: true,
      search: true,
      selection: true
    }, columnType, {
      type: columnType,
      value: value || false,
      onChange: onChange
    }, status));
  } else if (type === "string") {
    return _react2.default.createElement(WrappedInput, (0, _extends3.default)({}, columnType, {
      value: value || "",
      onChange: onChange
    }, status));
  } else {
    return _react2.default.createElement('div', null, (0, _stringify2.default)(value));
  }
};

var DataGridEditor = function (_React$Component) {
  (0, _inherits3.default)(DataGridEditor, _React$Component);

  function DataGridEditor() {
    var _ref5;

    var _temp4, _this6, _ret4;

    (0, _classCallCheck3.default)(this, DataGridEditor);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref5 = DataGridEditor.__proto__ || (0, _getPrototypeOf2.default)(DataGridEditor)).call.apply(_ref5, [this].concat(args))), _this6), _this6.state = {
      blurCurrentFocus: false
    }, _this6.handleChange = function (row, key, update) {
      var context = _this6.props.context;
      var value = context.value,
          path = context.path,
          onChange = context.onChange;
      var index = (0, _lodash.indexOf)(value, row);
      console.log("Value ", update);
      var delta = update === undefined ? null : update;
      console.log("Trying to ", delta);

      if (index >= 0) {
        onChange([].concat((0, _toConsumableArray3.default)(path), [index, key]), delta);
      }

      _this6.setState({
        blurCurrentFocus: true
      });
    }, _this6.addRow = function () {
      var _this6$props = _this6.props,
          type = _this6$props.type,
          context = _this6$props.context;
      var value = context.value,
          path = context.path,
          onChange = context.onChange;
      var count = (0, _lodash.size)(value);
      var defaultValue = (0, _lodash.mapValues)(type.of, function (type, key) {
        var columnType = typeof type === "string" ? {
          type: type
        } : type;

        if (columnType.type === "string") {
          return "";
        } else if (columnType.type === "boolean") {
          return false;
        } else if (columnType.type === "number") {
          return 0;
        } else {
          return null;
        }
      });
      onChange([].concat((0, _toConsumableArray3.default)(path), [count]), defaultValue);
    }, _this6.deleteRow = function (row) {
      var context = _this6.props.context;
      var value = context.value,
          path = context.path,
          onChange = context.onChange;
      onChange([].concat((0, _toConsumableArray3.default)(path)), (0, _lodash.without)(value, row));
    }, _temp4), (0, _possibleConstructorReturn3.default)(_this6, _ret4);
  }

  (0, _createClass3.default)(DataGridEditor, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props = this.props,
          name = _props.name,
          type = _props.type,
          context = _props.context;
      var value = context.value,
          current = context.current,
          path = context.path,
          onChange = context.onChange;
      var description = type.description,
          label = type.label,
          _type$variant = type.variant,
          variant = _type$variant === undefined ? "primary" : _type$variant;
      var columns = (0, _lodash.chain)(type.of).map(function (type, key) {
        var columnType = typeof type === "string" ? {
          type: type
        } : type;
        return {
          id: key,
          title: key,
          value: function value(row, status) {
            return getEditor(columnType, function (v) {
              return _this7.handleChange(row, key, v);
            }, row[key], status);
          }
        };
      }) // .sortBy([orderColumns(materialType)])
      .value();
      columns.push({
        id: '$$delete',
        title: "",
        value: function value(row, status) {
          return _react2.default.createElement(_reactFulcrum.Button, {
            onClick: function onClick() {
              return _this7.deleteRow(row);
            }
          }, 'Delete');
        }
      });
      return _react2.default.createElement('div', {
        className: 'DataGridEditor variant-' + variant
      }, _react2.default.createElement(_reactSpreadsheetGrid.Grid, {
        focusOnSingleClick: true,
        isColumnsResizable: true,
        rowHeight: 60,
        columns: columns,
        rows: value,
        getRowKey: function getRowKey(row) {
          return value.indexOf(row);
        },
        blurCurrentFocus: this.state.blurCurrentFocus
      }), _react2.default.createElement('div', null, _react2.default.createElement(_reactFulcrum.Button, {
        onClick: this.addRow
      }, 'Add')));
    }
  }]);
  return DataGridEditor;
}(_react2.default.Component);

exports.default = DataGridEditor;